import PickEntity from '../utils/pick-entity/pick-entity.js'
import CostReport from './cost-report/cost-report.js'
import AzBudgetComponent from './file-reader-azbudget/component.js'

import '@local_modules/generic/web-paint/styles/data.css'

export default class PpAZBudget {
  constructor () {
    console.log('PpAZBudget constructor')
    this.htmlTemplate = `
      <wp-container class="as-full-height width-full">
        <wp-container class="as-row">
          <div>zenflow account:</div> <input type="text" id="app-account-id" class="width-full"/>
        </wp-container>

        <div id="az-budget-container"></div>

        <wp-container id="entity-picker" class="width-full"></wp-container>

        <wp-container id="cost-report-container" class="as-fill-space width-full">COST REPORT</wp-container>
      </wp-container>
    `

    this.mountedOn = null
    this.data = {
      budget: null,
      ledgerAccounts: null
    }

    this.numberPowTen = 4
  }

  mount (element) {
    console.log('PpAZBudget mount')
    element.innerHTML = this.htmlTemplate
    this.mountedOn = element

    document.body.classList.add('webpaint')

    this.render()
  }

  render () {
    console.log('PpAZBudget render')
    if (!this.mountedOn) return

    manageAppAccountId(this)

    this.azBudget = new AzBudgetComponent({
      numberPowTen: this.numberPowTen
    })
    this.azBudget.mount(this.mountedOn.querySelector('#az-budget-container'))

    this.costReport = new CostReport({
      numberPowTen: this.numberPowTen
    })
    this.costReport.mount(this.mountedOn.querySelector('#cost-report-container'))

    addListeners(this)
  }
}

function addListeners (instance) {
  console.log('addListeners')
  if (!instance.mountedOn) return

  instance.mountedOn.addEventListener('pp:onBudgetFileRead', (event) => {
    console.log('PpAZBudget pp:onBudgetFileRead', event)
  })
}

async function manageAppAccountId (instance) {
  console.log('manageAppAccountId')
  if (!instance.mountedOn) return

  instance.mountedOn.querySelector('#app-account-id').addEventListener('change', async (event) => {
    console.log('appAccountId changed', event.target.value)
    localStorage.setItem('appAccountId', event.target.value)

    await showEntityPicker(instance)
  })

  function initAppAccountId () {
    console.log('initAppAccountId')
    const defaultAppAccountId = '8aa0631b-fcce-49d8-bfa5-1a20899b9a6a'
    const browserAppAccountId = localStorage.getItem('appAccountId')
    const currentAppAccountId = browserAppAccountId || defaultAppAccountId
    localStorage.setItem('appAccountId', currentAppAccountId)
    console.log('initAppAccountId done', currentAppAccountId)
  }

  initAppAccountId()
  instance.mountedOn.querySelector('#app-account-id').value = localStorage.getItem('appAccountId')

  instance.entityPicker = new PickEntity()
  await showEntityPicker(instance)
}

async function showEntityPicker (instance) {
  console.log('showEntityPicker')
  if (!instance.mountedOn) return

  instance.appAccountId = localStorage.getItem('appAccountId')

  instance.entityPicker.mount(instance.mountedOn.querySelector('#entity-picker'))
  await instance.entityPicker.loadEntities(instance.appAccountId)
  instance.entityPicker.render()

  instance.entityPicker.mountedOn.addEventListener('pp:onEntitySelectionChange', (event) => {
    console.log('pp:onEntitySelectionChange', event)
    instance.accountingOrganisationId = event.detail.accountingOrganisationId
  })

  instance.entityPicker.mountedOn.addEventListener('pp:loadedLedgerAccountsAndFinancialStatement', (event) => {
    console.log('pp:loadedLedgerAccountsAndFinancialStatement', event)
    instance.data.ledgerAccounts = event.detail.ledgerAccounts
    instance.data.financialStatement = event.detail.financialStatement

    instance.budgetGrid.render({
      data: instance.data,
      accountingOrganisationId: instance.accountingOrganisationId,
      numberPowTen: instance.numberPowTen
    })
  })
}
